import type { NegotiationVariableContext } from './context'
import { defineVariable, type NegotiationVariable } from './define'

/**
 * Helper de autoría para un OBJETO del dominio expuesto como grupo de variables punteadas
 * (`prefijo.campo`).
 *
 * Por debajo usa `defineVariable` — no hay un segundo camino: produce variables normales del
 * registry. Lo que cambió con el ADR 0036 es de dónde sale el metadato: el grupo se declara en
 * `@idc-forms/schemas/variables/document/*` con `documentVariableGroup` (mismo prefijo, misma
 * etiqueta de grupo, mismos campos) y acá queda el `resolve` de cada campo.
 *
 * Ejemplo:
 *   export const LUGAR_VARIABLES = defineObjectGroup('lugar', {
 *     pais:      (c) => c.lugar?.pais ?? '',
 *     municipio: (c) => c.lugar?.municipio ?? ''
 *   }) // → [{ key:'lugar.pais', group:'Ubicación', ... }, ...]
 *
 * El ORDEN de este mapa es el orden en el picker, y tiene que ser el mismo que el del paquete —
 * `registry.spec.ts` lo fija: el catálogo y el registry declaran las mismas keys en el mismo orden.
 */

type Resolve = (ctx: NegotiationVariableContext) => string

export const defineObjectGroup = (
  prefix: string,
  fields: Record<string, Resolve>
): NegotiationVariable[] =>
  Object.entries(fields).map(([key, resolve]) => defineVariable(`${prefix}.${key}`, resolve))
